import { CalculationRule } from "@/helpers/types/types.ts";
import { t } from "i18next";

export const translateCalculationRule = (rule: CalculationRule) => {
  switch (rule) {
    case CalculationRule.PerDay:
      return t("calculationRule.perDay");
    case CalculationRule.PerPerson:
      return t("calculationRule.perPerson");
    case CalculationRule.PerPersonPerDay:
      return t("calculationRule.perPersonPerDay");
    case CalculationRule.PerUnit:
      return t("calculationRule.perUnit");
    default:
      return "Unknown rule";
  }
};
